export default __webpack_public_path__ + "placeholder.fe4c95f7.svg";